import { IGeocodingLocation } from '../../../../../../../core/src'
import { GeocodingLocationFactory } from '../../../geocoding/geocoding-location.factory'

const httpOkResponse = 'OK'

export class ZipcodeGetters {
  static geocode(results: google.maps.GeocoderResult[] | null, status: any): IGeocodingLocation | undefined {
    if (!results || results.length === 0) return undefined
    if (status === httpOkResponse) {
      const formattedAddress = results![0].formatted_address
      const geocoding = GeocodingLocationFactory.fromGeocodingArrayFactory(results![0].address_components)
      geocoding.address = formattedAddress
      return geocoding
    }
    return undefined
  }
}
